import * as CONFIGS from "@/statics/configs.js";

const NODE14 = {
  NAME: "TS4C",
  INPUT1: {
    NAME: "NODE14_INPUT1_NAME",
    TYPE: "zeroContact",
    ICON: "switch",
    PARAMETER_ID: 0x8020,
  },
  INPUT2: {
    NAME: "NODE14_INPUT2_NAME",
    TYPE: "zeroContact",
    ICON: "switch",
    PARAMETER_ID: 0x8021,
  },
  INPUT3: {
    NAME: "NODE14_INPUT3_NAME",
    TYPE: "zeroContact",
    ICON: "switch",
    PARAMETER_ID: 0x8022,
  },
  INPUT4: {
    NAME: "NODE14_INPUT4_NAME",
    TYPE: "zeroContact",
    ICON: "switch",
    PARAMETER_ID: 0x8023,
  },
  AUTOENABLE1: {
    NAME: "NODE14_AUTOENABLE1_NAME",
    PARAMETER_ID: 0xE030,
  },
  AUTOENABLE2: {
    NAME: "NODE14_AUTOENABLE2_NAME",
    PARAMETER_ID: 0xE031,
  },
  AUTOENABLE3: {
    NAME: "NODE14_AUTOENABLE3_NAME",
    PARAMETER_ID: 0xE032,
  },
  AUTOENABLE4: {
    NAME: "NODE14_AUTOENABLE4_NAME",
    PARAMETER_ID: 0xE033,
  },
  OUTPUT1: {
    NAME: "NODE14_OUTPUT1_NAME",
    TYPE: "RelaySSR2A",
    ICON: "lamp",
    PARAMETER_ID: 0xe010,
  },
  OUTPUT2: {
    NAME: "NODE14_OUTPUT2_NAME",
    TYPE: "RelaySSR2A",
    ICON: "lamp",
    PARAMETER_ID: 0xe011,
  },
  OUTPUT3: {
    NAME: "NODE14_OUTPUT3_NAME",
    TYPE: "RelaySSR2A",
    ICON: "lamp",
    PARAMETER_ID: 0xe012,
  },
  OUTPUT4: {
    NAME: "NODE14_OUTPUT4_NAME",
    TYPE: "RelaySSR2A",
    ICON: "lamp",
    PARAMETER_ID: 0xe013,
  },
  LEDSTATE1: {
    NAME: "NODE14_LEDSTATE1_NAME",
    TYPE: "LED",
    ICON: "lamp",
    PARAMETER_ID: 0xE120,
  },
  LEDSTATE2: {
    NAME: "NODE14_LEDSTATE2_NAME",
    TYPE: "LED",
    ICON: "lamp",
    PARAMETER_ID: 0xE121,
  },
  LEDSTATE3: {
    NAME: "NODE14_LEDSTATE3_NAME",
    TYPE: "LED",
    ICON: "lamp",
    PARAMETER_ID: 0xE122,
  },
  LEDSTATE4: {
    NAME: "NODE14_LEDSTATE4_NAME",
    TYPE: "LED",
    ICON: "lamp",
    PARAMETER_ID: 0xE123,
  },
  TEMPERATURE: {
    NAME: "NODE14_TEMPERATURE_NAME",
    TYPE: "internalTemperature",
    ICON: "temperature",
    PARAMETER_ID: 0x8101,
  },
  NOTIFY_HUB: {
    PARAMETER_ID: 0x6100,
  },
  RELAY1_INIT: {
    PARAMETER_ID: 0xe110,
  },
  RELAY2_INIT: {
    PARAMETER_ID: 0xe111,
  },
  RELAY3_INIT: {
    PARAMETER_ID: 0xe112,
  },
  LORA_RSSI: {
    PARAMETER_ID: 0x8102,
  },
  LORA_SNR: {
    PARAMETER_ID: 0x8103,
  },
};
NODE14.DEFAULT_INSTRUCTIONS = [
  [
    {
      eventToWatch: {
        parameterId: NODE14.INPUT1.PARAMETER_ID,
        valueToReach: 0,
        direction: CONFIGS.EVENT_DIRECTION_FALLING
      },
      internalAction: {
        parameterId: NODE14.NOTIFY_HUB.PARAMETER_ID,
        valueOfChange: 0,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
      timeDelay: 0
    },
    {
      eventToWatch: {
        parameterId: NODE14.INPUT2.PARAMETER_ID,
        valueToReach: 0,
        direction: CONFIGS.EVENT_DIRECTION_FALLING
      },
      internalAction: {
        parameterId: NODE14.NOTIFY_HUB.PARAMETER_ID,
        valueOfChange: 0,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
      timeDelay: 0
    },
    {
      eventToWatch: {
        parameterId: NODE14.INPUT3.PARAMETER_ID,
        valueToReach: 0,
        direction: CONFIGS.EVENT_DIRECTION_FALLING
      },
      internalAction: {
        parameterId: NODE14.NOTIFY_HUB.PARAMETER_ID,
        valueOfChange: 0,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
      timeDelay: 0
    },
    {
      eventToWatch: {
        parameterId: NODE14.INPUT4.PARAMETER_ID,
        valueToReach: 0,
        direction: CONFIGS.EVENT_DIRECTION_FALLING
      },
      internalAction: {
        parameterId: NODE14.NOTIFY_HUB.PARAMETER_ID,
        valueOfChange: 0,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
      timeDelay: 0
    },
  ],
];

export default NODE14;
